import _flatMapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/flat-map";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/reduce";
import { computed, ref } from "@vue/composition-api";
import { useVuelidate } from "@vuelidate/core";
import { between } from "@vuelidate/validators";
import { futureDate, withValidDate } from "@Shared/@Utils/validation-rules";
import { getValidationRulesFromMap } from "@Client/@Composables/application-standalone/validations/getValidationRulesFromMap";
import * as ApplicationStandaloneGetters from "@Client/@Modules/application-standalone/store/application-standalone-getters";
import { useApplicationStandaloneStoreGetters } from "@Client/@Modules/application-standalone/store/application-standalone-helpers";
import { liabilitiesPageBindingsAndVisibilities } from "@Client/@Composables/application-standalone/pages/liabilities/liabilitiesPageBindingsAndVisibilities";
import { useApplicantHelpers } from "@Client/@Composables/application-standalone/pages/applicants/useApplicantHelpers";
import { camelCase, capitalize, mapKeys } from "lodash";
export const liabilityValidator = (applicantIndex, liabilityIndex, {
  lazy = false
} = {}) => {
  const {
    bindings
  } = liabilitiesPageBindingsAndVisibilities(applicantIndex, liabilityIndex, ref("0"));
  const {
    liabilityType,
    liabilityLimit,
    liabilityBalance,
    liabilityPayment,
    liabilityMaturityDate,
    liabilityPayoff,
    liabilityDescription
  } = bindings;
  const applicantPrefix = computed(() => {
    return applicantIndex.value ? "applicant" : "";
  });
  const {
    GET_SCHEMA_RULES_BY_PATH,
    HAS_CONSOLIDATED_REQUEST
  } = useApplicationStandaloneStoreGetters([ApplicationStandaloneGetters.GET_SCHEMA_RULES_BY_PATH, ApplicationStandaloneGetters.HAS_CONSOLIDATED_REQUEST]);
  const {
    isApplicantVisibleFromFillOut,
    getApplicantIdByIndex
  } = useApplicantHelpers();
  const areRulesVisibleFromFillOut = () => !HAS_CONSOLIDATED_REQUEST.value || isApplicantVisibleFromFillOut(getApplicantIdByIndex(applicantIndex.value));
  const rules = computed(() => {
    return getValidationRulesFromMap(areRulesVisibleFromFillOut, GET_SCHEMA_RULES_BY_PATH, liabilityPageRules, applicantPrefix.value, {
      "co-applicants": applicantIndex.value - 1,
      liabilities: liabilityIndex.value
    });
  });
  const v$ = useVuelidate(rules, {
    liabilityType,
    liabilityLimit,
    liabilityBalance,
    liabilityPayment,
    liabilityMaturityDate,
    liabilityPayoff,
    liabilityDescription
  }, {
    $scope: true,
    $lazy: lazy
  });
  return {
    v$
  };
};
const liabilityPageRules = {
  liabilityType: {},
  liabilityLimit: {
    between: between(0, 1000000000000)
  },
  liabilityBalance: {
    between: between(0, 1000000000000)
  },
  liabilityPayment: {
    between: between(0, 1000000000000)
  },
  liabilityMaturityDate: {
    withValidDate: () => withValidDate,
    futureDate: () => futureDate
  },
  liabilityPayoff: {},
  liabilityDescription: {}
};
export const liabilitiesValidator = ({
  lazy = false
} = {}) => {
  const {
    GET_SCHEMA_RULES_BY_PATH
  } = useApplicationStandaloneStoreGetters([ApplicationStandaloneGetters.GET_SCHEMA_RULES_BY_PATH]);
  const {
    allLiabilities: liabilities
  } = useApplicantHelpers();
  const {
    isApplicantVisibleFromFillOut
  } = useApplicantHelpers();
  const allLiabilities = computed(() => {
    var _context;
    return _flatMapInstanceProperty(_context = liabilities.value).call(_context, item => isApplicantVisibleFromFillOut(item.applicantId) ? mapKeys(item, (_value, key) => camelCase("liability" + capitalize(key))) : []);
  });
  const getRules = () => {
    var _context2;
    const mainApplicantRules = index => getValidationRulesFromMap(() => true, GET_SCHEMA_RULES_BY_PATH, liabilityPageRules, "", {
      liabilities: index
    });
    const coApplicantRules = (applicantIndex, index) => getValidationRulesFromMap(() => true, GET_SCHEMA_RULES_BY_PATH, liabilityPageRules, "applicant", {
      "co-applicants": applicantIndex - 1,
      liabilities: index
    });
    return _reduceInstanceProperty(_context2 = allLiabilities.value).call(_context2, (acc, liabilities, index) => {
      acc[index] = liabilities.applicantIndex ? coApplicantRules(liabilities.index, liabilities.liabilityIndex) : mainApplicantRules(liabilities.liabilityIndex);
      return acc;
    }, {});
  };
  const rules = computed(getRules);
  const v$ = useVuelidate(rules, allLiabilities, {
    $scope: "liabilityArray",
    $lazy: lazy
  });
  return {
    v$
  };
};